import React, { memo } from 'react';

import AddUserButton from './add-user-button/AddUserButton';
import UsersTable from './users-table/UsersTable';

const EditUsers = () => {
  return (
    <>
      <AddUserButton />
      <UsersTable />
    </>
  );
};

export default memo(EditUsers);
